import React from "react";
import { decimalTo } from '../../utils/utils';



export const SalesDataColumns = (handleRouteSale,region) => {




   return [
    {
      name: "S.No",
      cell: (row, index) => (
        <>
          <input type="hidden" value={row.dateVelue} />
          <span>{row.pageCount ?? index + 1}</span>
        </>
      ),
      sortable: false,
    },
    {
      name: "Date",
      selector: (row) => row.dateVelue,
      cell: (row) => (
        <span
     
          onClick={(e) => {
            e.preventDefault();
            handleRouteSale(row);
          }}
        >
          {row.dateVelue}
        </span>
      ),
    },
    {
      name: `Total Net Amount${region?.currency ? ` (${region.currency})` : ''}`,
      selector: (row) => row.totalAmount,
      cell: (row) => (
        <span>{row?.totalAmount != null ? decimalTo(row.totalAmount).toFixed(2) : "0.00"}</span>
      ),
    },
    {
      name: "Total Orders",
      selector: (row) => row.totalOrders,
    },
    
  ];
};

export const SalesDateColumnsforSuperAdmin = (handleRouteSaleAdmin,region) => {


  return [
    {
      name: "S.No",
      cell: (row, index) => (
        <>
          <input type="hidden" value={row.dateVelue} />
          <span>{row.pageCount ?? index + 1}</span>
        </>
      ),
      sortable: false,
    },
    {
      name: "Date",
      selector: (row) => row.dateVelue,
      cell: (row) => (
        <span
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleRouteSaleAdmin(row);
          }}
        >
          {row.dateVelue}
        </span>
      ),
    },
    {
      name: `Total Net Amount${region?.currency ? ` (${region.currency})` : ''}`,
      selector: (row) => row.totalAmount,
      cell: (row) => (
        <span>{row?.totalAmount != null ? decimalTo(row.totalAmount).toFixed(2) : "0.00"}</span>
      ),
    },
    {
      name: "Total Orders",
      selector: (row) => row.totalOrders,
    },
    
  ];
};

export const KeyReportColumns = () => {
  return [
    {
      name: "S.No", width: "80px",
      cell: (row, index) => (
        <>
          <input type="hidden" value={row.dateVelue} />
          <span>{row.pageCount ?? index + 1}</span>
        </>
      ),
      sortable: false,
     
    },
    {
      name: "Product Key",width: "200px",
      selector: (row) => row.productKeyMask,
    },
    {
      name: "Created At",
      cell: (row) => {
        const formatted = row.createdAt
          ? new Date(row.createdAt).toLocaleDateString("en-CA")
          : "";
        return <span>{formatted}</span>;
      },
    },
    {
      name: "Updated At",
      cell: (row) => {
        const formatted = row.updatedAt
          ? new Date(row.updatedAt).toLocaleDateString("en-CA")
          : "";
        return <span>{formatted}</span>;
      },
    },
    {
      name: "Master Product",
      cell: (row) =>
        row.masterproductname ? (
          <span className="add-ellip">{row.masterproductname}</span>
        ) : null,
    },
    {
      name: "Merchant Name",
      cell: (row) =>
        row.merchant ? (
          <span className="add-ellip">{row.merchant ?? "null"}</span>
        ) : null,
    },
    {
      name: "Order ID",
      cell: (row) =>
        row.orderId ? (
          <span className="add-ellip">{row.orderId ?? "null"}</span>
        ) : null,
    },
    {
      name: "Status",
      cell: (row) =>
        row.orderId !== null ? (
          <span className="product-active">Used</span>
        ) : (
          <span>Unused</span>
        ),
    },
  ];
};


